import './HomePageFooter.css'
import { Link } from 'react-router-dom';

const HomePageFooter = () => {
    return (
        <footer>
            <div className='main-footer'>
                <div className="container">
                    <div className="footer-section">
                        <div className='row'>
                            <div className='col-md-4'>
                                    <div className='first-section'>
                                        <a href="#"><img className="footer-logo" src='../../../../images/chitkara-logo.svg' alt="logo" /></a>
                                        <h4 className='logo-content'>Explore Your Potential</h4>
                                        {/* <img className="footer-logo" src='../../../../images/chitkara-logo.svg' alt="logo" /> */}
                                    <div className="social-logos">
                                        <ul className="nav nav-pill">
                                            <li className="nav-item">
                                                <a href="#facebook"><img src="../../../../images/facebook-logo.svg" alt="facebooklogo" /></a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="#twitter"><img src="../../../../images/twiter-logo.svg" alt="twitterlogo" /></a>
                                            </li>
                                            <li className="nav-item">
                                            <a href="#linkedin"><img src="../../../../images/linkedin-logo.svg" alt="linkedinlogo" /></a>
                                            </li>
                                            <li className="nav-item">
                                            <a href="#instagram"><img src="../../../../images/insta-logo.svg" alt="instagramlogo" /></a>
                                            </li>
                                            <li className="nav-item">
                                            <a href="#youtube"><img src="../../../../images/youtube-logo.svg" alt="youtubelogo" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                    </div>
                            </div>

                            <div className='col-md-4'>
                            <div className='line'>
                                <div className='second-section'>
                                    <h5>Chitkara University</h5>
                                    <p>India's top rated university</p>
                                    <p>Chandigarh-Patiala National Highway, Punab 140 401</p>
                                    <p>Chandigarh Information Center SCO 160-161, Sector 9-C, Chandigarh 160 009</p>
                                </div>
                            </div>
                            </div>

                            <div className='col-md-4'>
                                <div class='third-section'>
                                    <ul className="nav nav-pill">
                                        <li className="nav-item">
                                            <Link to="#" class="nav-link">Upcoming Events</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="#" class="nav-link">Past Events</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="#" class="nav-link">Contact Us</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to="/auth/login" class="nav-link">Login</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className='copyright-section'>
                            <div className='copyright'>
                                <p>&copy; 2022 Chitkara University. All rights reserved.</p>
                            </div>
                            <div className="footer-navbar">
                                <ul className="nav nav-pill">
                                    <li className="nav-item">
                                        <a href="#" class="nav-link">Terms</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" class="nav-link">Privacy</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#" class="nav-link">Cookies</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomePageFooter;


